/** Strapi `pages` slugs this app may load (see Strapi / API). */
export const ALLOWED_CMS_PAGE_SLUGS: readonly string[] = ['faqs', 'partners', 'terms', 'privacy', 'glossary'];

/**
 * Maps `location.pathname` (no trailing slash) to Strapi page slug when the page is mounted
 * on a top-level route (e.g. `path="terms-of-use"`) instead of `cms/:slug`.
 */
export const CMS_PAGE_PATH_TO_SLUG: Readonly<Record<string, string>> = {
    '/faqs': 'faqs',
    '/glossary': 'glossary',
    '/terms-of-use': 'terms',
    '/privacy-policy': 'privacy',
    '/partners': 'partners',
    '/partners-and-vendors': 'partners',
    '/partners-and-data-sources': 'partners',
};

/**
 * The one public path each page is indexed under, for `<link rel="canonical">`. Aliases such as
 * `/partners` resolve to the same page, so they all point here; must agree with the sitemap's
 * `PUBLIC_STATIC_PATHS`. A slug not listed is only reachable as `/cms/:slug`.
 */
const CMS_PAGE_CANONICAL_PATH: Readonly<Record<string, string>> = {
    faqs: '/faqs',
    glossary: '/glossary',
    terms: '/terms-of-use',
    privacy: '/privacy-policy',
    partners: '/partners-and-vendors',
};

export function cmsPageCanonicalPath(slug: string): string {
    return CMS_PAGE_CANONICAL_PATH[slug] ?? `/cms/${encodeURIComponent(slug)}`;
}

function normalizePathname(pathname: string): string {
    if (pathname.length > 1 && pathname.endsWith('/')) {
        return pathname.replace(/\/+$/, '');
    }
    return pathname || '/';
}

/**
 * Resolves Strapi slug: explicit prop wins, then `cms/:slug` param, then known public path.
 */
export function resolveCmsPageSlug(pathname: string, paramSlug: string | undefined, propSlug: string | undefined): string | null {
    const fromProp = propSlug?.trim();
    if (fromProp) return fromProp;
    const fromParam = paramSlug?.trim();
    if (fromParam) return fromParam;
    const path = normalizePathname(pathname);
    return CMS_PAGE_PATH_TO_SLUG[path] ?? null;
}
